import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactInformationComponent } from './contact-information.component';
import { StaticMsgModule } from '@lib/pipes';
import { ContactInformationToUsModule } from '../contact-information-to-us/contact-information-to-us.module';
import { PhoneNumberModule } from '../../pipes/phone-number/phone-number.module';

@NgModule({
  declarations: [ContactInformationComponent],
  imports: [CommonModule, StaticMsgModule, ContactInformationToUsModule, PhoneNumberModule],
  exports: [ContactInformationComponent],
})
export class ContactInformationModule {}
